const NAME = "FAVOURITE_BUTTON";

export default NAME;
